// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import getAxisFromEventFieldName from '../getAxisFromEventFieldName'
import handleCoordinateFieldFormatting from '../handleCoordinateFieldFormatting'

const handleOnBlurCoordinateField = (e, applyChange) => {
  const axis = getAxisFromEventFieldName(e)
  const value = e.target.value.trim()
  handleCoordinateFieldFormatting(value, axis, applyChange)
}

export default handleOnBlurCoordinateField
